var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-feed u-bottom-margin" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        !_vm.hideTagList &&
        _vm.tagsLoaded &&
        _vm.initialFeedLoaded &&
        _vm.tagList.length
          ? _c(
              "div",
              { staticClass: "o-container" },
              [
                _c("div", { staticClass: "mobile-toggle" }, [
                  _c(
                    "button",
                    {
                      staticClass: "mobile-toggle__button",
                      class: {
                        "mobile-toggle__button--active": _vm.showFilterAtMobile
                      },
                      on: { click: _vm.toggleMobileFilter }
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [_vm._v("Open")]),
                      _vm._v(" Filters\n        ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("app-filter", {
                  class: {
                    "tag-filter--show-at-mobile": _vm.showFilterAtMobile
                  },
                  attrs: {
                    tags: _vm.tagList,
                    "default-selected-tags": _vm.selectedTags
                  },
                  on: { selectedCategory: _vm.updateTagQs }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "o-container o-container o-container--half-padding" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _vm.feedLoaded
              ? _c(
                  "div",
                  { key: "results" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.set[0].children.length
                          ? _c(
                              "div",
                              { staticClass: "c-article-list" },
                              [
                                _vm._l(_vm.set, function(item, index) {
                                  return _c("listing-feed-set", {
                                    key: "set-" + index,
                                    attrs: {
                                      "hide-tags": _vm.hideTags,
                                      layout: _vm.renderedLayoutType,
                                      "hierarchical-headings":
                                        _vm.hierarchicalHeadings,
                                      "default-selected-tags": _vm.selectedTags,
                                      data: item.children
                                    }
                                  })
                                }),
                                _vm._v(" "),
                                _vm.isLoadingMoreResults
                                  ? _c(
                                      "div",
                                      { staticClass: "listing-feed__message" },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading")
                                        ]),
                                        _vm._v(" "),
                                        _c("loader")
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("app-paging", {
                                  attrs: {
                                    "current-page": _vm.currentPage,
                                    "total-pages": _vm.totalPages,
                                    "current-visible-items-count":
                                      _vm.currentVisibleArticleItemCount,
                                    "total-items-count":
                                      _vm.totalArticleItemCount
                                  },
                                  on: { loadMoreClicked: _vm.fetchData }
                                })
                              ],
                              2
                            )
                          : _c("p", { staticClass: "listing-feed__message" }, [
                              _vm._v(
                                "\n            Sorry, no results. Please try adjusting the filters.\n          "
                              )
                            ])
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { key: "loading", staticClass: "listing-feed__message" },
                  [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Loading")]),
                    _vm._v(" "),
                    _c("loader")
                  ],
                  1
                )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }